import { Component } from '@angular/core';
import { ReportDiscountsService } from '../../services/report_discounts.service';
import { PeriodService } from '../../../periods/period.service';
import Swal from 'sweetalert2';
import { UserService } from '../../../user/services/user.service';

@Component({
  selector: 'app-employee-discounts',
  templateUrl: './admin-employee-discounts.component.html',
  styleUrl: './admin-employee-discounts.component.scss'
})
export class AdminEmployeeDiscountsComponent {
  selectedUserId: string = ''
  selectedPeriod: any =''
  currentYear: number = new Date().getFullYear();
  periods: any[] = []
  users: any[] = []


  constructor(
    private reportDiscountsService: ReportDiscountsService,
    private periodService: PeriodService,
    private userService: UserService,
    private reportDiscountService: ReportDiscountsService
  ) {

  }
  ngOnInit() {
    this.loadPeriods();
    this.loadUsers();
  }

  loadPeriods() {
    this.periodService.get(this.currentYear, false).subscribe({
      next: (response) => {
        this.periods = response;
      },
      error: (error) => {
        console.error('Error al cargar los Periodos:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar los periodos',
        });
      }
    })
  }


  
  loadUsers() {
    this.userService.get(true).subscribe({
      next: (response) => {
        this.users = response.users;
      },
      error: (error) => {
        console.error('Error al cargar los usuarios:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar los usuarios',
        });
      }
    })
  }

  searchDiscount() {
    this.reportDiscountsService.setcurrentFilter({
      userId: this.selectedUserId,
      periodId: this.selectedPeriod._id,
      periodIsClosed: this.selectedPeriod.isClosed
    })
  }

  openModal() {
    this.reportDiscountService.setCloseModal(false)
  }

  generateResumeDiscounts() {
    this.reportDiscountsService.generateResumeDiscounts().subscribe(blob =>{
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Resumen_Descuentos.xlsx`;
      link.click();
      window.URL.revokeObjectURL(url);
    })
    
  }

}
